import React from 'react';
import { SignUp as ClerkSignUp } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import '../styles/auth.css';

const SignUp = () => {
  const navigate = useNavigate();

  return (
    <div className="auth-container">
      <div className="auth-background blueprint-grid-dark"></div>
      
      <div className="auth-content">
        <div className="auth-brand">
          <div className="auth-brand-logo">
            <span className="auth-brand-icon">C</span>
          </div>
          <h1 className="auth-title">Civily</h1>
          <p className="auth-subtitle">AI-powered quantity extraction for civil estimators</p>
        </div>

        <div className="auth-card">
          <ClerkSignUp 
            routing="path"
            path="/signup"
            afterSignUpUrl="/app"
            signInUrl="/login"
            appearance={{
              variables: {
                colorPrimary: '#E8541A',
                colorBackground: '#F5F4F1',
                colorInputBackground: '#FFFFFF',
                colorInputText: '#2C3748',
                colorText: '#2C3748',
                colorTextSecondary: '#64748B',
                colorBorder: '#E2E8F0',
                colorDanger: '#DC2626',
                colorSuccess: '#059669',
                fontFamily: 'DM Sans, sans-serif',
                fontFamilyButtons: 'DM Sans, sans-serif',
                borderRadius: '8px',
                spacingUnit: '4px'
              },
              elements: {
                rootBox: 'clerk-root',
                card: 'clerk-card',
                headerTitle: 'clerk-header-title',
                headerSubtitle: 'clerk-header-subtitle',
                socialButtonsBlockButton: 'clerk-social-button',
                formButtonPrimary: 'clerk-button-primary',
                formFieldInput: 'clerk-input',
                footerActionLink: 'clerk-link',
                identityPreviewText: 'clerk-identity-text',
                formFieldLabel: 'clerk-label',
                formFieldErrorText: 'clerk-error-text',
                dividerLine: 'clerk-divider',
                dividerText: 'clerk-divider-text',
                formButtonSecondary: 'clerk-button-secondary',
                formFieldSuccessText: 'clerk-success-text',
                alert: 'clerk-alert',
                alertText: 'clerk-alert-text',
                avatarImage: 'clerk-avatar',
                avatarBox: 'clerk-avatar-box',
                form: 'clerk-form',
                formField: 'clerk-form-field',
                header: 'clerk-header',
                main: 'clerk-main',
                footer: 'clerk-footer',
                socialButtons: 'clerk-social-buttons',
                socialButtonsBlockButton: 'clerk-social-button',
                socialButtonsIconButton: 'clerk-social-icon-button',
                socialButtonsSeparator: 'clerk-social-separator',
                formResendButton: 'clerk-resend-button',
                formAction: 'clerk-form-action',
                formHeader: 'clerk-form-header',
                formBody: 'clerk-form-body',
                formFooter: 'clerk-form-footer',
                formButtonRow: 'clerk-button-row',
                formFieldRow: 'clerk-field-row',
                formFieldCheckbox: 'clerk-checkbox',
                formFieldCheckboxContainer: 'clerk-checkbox-container',
                formFieldRadio: 'clerk-radio',
                formFieldRadioContainer: 'clerk-radio-container',
                formFieldSelect: 'clerk-select',
                formFieldTextArea: 'clerk-textarea',
                formFieldSwitch: 'clerk-switch',
                formFieldSwitchContainer: 'clerk-switch-container',
                formFieldSlider: 'clerk-slider',
                formFieldSliderContainer: 'clerk-slider-container',
                formFieldFileUpload: 'clerk-file-upload',
                formFieldFileUploadContainer: 'clerk-file-upload-container',
                formFieldDateInput: 'clerk-date-input',
                formFieldTimeInput: 'clerk-time-input',
                formFieldDateTimeInput: 'clerk-datetime-input',
                formFieldColorInput: 'clerk-color-input',
                formFieldRangeInput: 'clerk-range-input',
                formFieldNumberInput: 'clerk-number-input',
                formFieldPasswordInput: 'clerk-password-input',
                formFieldEmailInput: 'clerk-email-input',
                formFieldPhoneInput: 'clerk-phone-input',
                formFieldUrlInput: 'clerk-url-input',
                formFieldTextInput: 'clerk-text-input',
                formFieldSearchInput: 'clerk-search-input',
                formFieldHiddenInput: 'clerk-hidden-input',
                formFieldButton: 'clerk-field-button',
                formFieldLink: 'clerk-field-link',
                formFieldImage: 'clerk-field-image',
                formFieldVideo: 'clerk-field-video',
                formFieldAudio: 'clerk-field-audio',
                formFieldEmbed: 'clerk-field-embed',
                formFieldCustom: 'clerk-field-custom'
              },
              layout: {
                socialButtonsPlacement: 'bottom',
                socialButtonsVariant: 'blockButton',
                logoPlacement: 'none',
                showOptionalFields: false,
                helpPageUrl: 'https://civilyapp.com/help'
              }
            }}
          />
        </div>

        <div className="auth-footer">
          <p>Already have an account? <button onClick={() => navigate('/login')} className="auth-link">Sign in</button></p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
